<template>
    <div class="flex" :class="message.is_message_by_authenticated_user ? 'justify-end' : 'justify-start'" :id="'message-'+message.id">
        <div class="w-10/12 message-box px-2" :class="message.is_message_by_authenticated_user ? 'right-triangle bg-gray-100' :
        'left-triangle bg-indigo-100'">
            <div class="font-bold mt-2 px-2 flex justify-between" v-if="!message.is_message_by_authenticated_user">
                <div>{{ message.sender_name }}</div>
                <button class="relative -my-1 outline-none transition duration-150 ease-in-out z-2"
                        @click="showDropdown = !showDropdown">

                    <svg class="w-4 h-4 my-2 text-gray-800" viewBox="0 0 24 24">
                        <path fill="currentColor"
                              d="M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z"/>
                    </svg>

                    <transition
                        enter-active-class="transition ease-out duration-100"
                        enter-class="transform opacity-0 scale-95"
                        enter-to-class="transform opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75"
                        leave-class="transform opacity-100 scale-100"
                        leave-to-class="transform opacity-0 scale-95">

                        <div class="absolute top-0 right-0 text-right mt-4 mr-4 w-40 z-20"
                             v-if="showDropdown">
                            <div class="z-10">
                                <div class="p-2 text-sm bg-white rounded-lg border shadow"
                                     :class="message.is_message_by_authenticated_user ? 'border-gray-200' : 'border-indigo-300'"
                                >
                                    <div class="hover:text-blue-500 px-3 py-1" @click="replySelected">Reply</div>
                                    <a v-if="message.media.length > 1" :href="'/messages/media/'+this.message.id" class="hover:text-blue-500 px-3 py-1">Download Media</a>
                                    <a v-if="message.media.length === 1" @click="download(message.media[0])" class="hover:text-blue-500 px-3 py-1">Download Media</a>
                                    <!--<div class="hover:text-blue-500" @click="()=>{}">Info</div>-->
                                </div>
                            </div>
                        </div>

                    </transition>
                </button>
            </div>
            <div class="w-full flex justify-end">
                <button v-if="message.is_message_by_authenticated_user"
                        class="relative pr-2 -mb-2 outline-none transition duration-150 ease-in-out z-2"
                        @click="showDropdown = !showDropdown">

                    <svg class="w-4 h-4 my-2 text-gray-800" viewBox="0 0 24 24">
                        <path fill="currentColor"
                              d="M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z"/>
                    </svg>

                    <transition
                        enter-active-class="transition ease-out duration-100"
                        enter-class="transform opacity-0 scale-95"
                        enter-to-class="transform opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75"
                        leave-class="transform opacity-100 scale-100"
                        leave-to-class="transform opacity-0 scale-95">
                        <div class="absolute top-0 right-0 text-right mt-4 mr-4 w-36 z-20"
                             v-if="showDropdown" v-click-outside="hideDropdown">
                            <div class="z-10">
                                <div class="p-2 text-sm bg-white rounded-lg border shadow"
                                     :class="message.is_message_by_authenticated_user ? 'border-gray-200' : 'border-indigo-300'"
                                >
                                    <div class="hover:text-blue-500 px-3 py-2" @click="replySelected">Reply</div>
                                    <a v-if="message.media.length > 1" :href="'/messages/media/'+this.message.id" class="hover:text-blue-500 px-3 py-2">Download Media</a>
                                    <a v-if="message.media.length === 1" @click="download(message.media[0])" class="hover:text-blue-500 px-3 py-2">Download Media</a>
                                    <!--<div class="hover:text-blue-500" @click="()=>{}">Info</div>-->
                                </div>
                            </div>
                        </div>
                    </transition>
                </button>
            </div>

            <div class="px-2 mb-2 mx-2">
                <!-- Show quoted Reply if applicable -->
                <div class="outline-none text-xs p-2 mt-2 rounded-lg mb-2 w-full"
                     v-if="message.replied_message"
                     :class="message.is_message_by_authenticated_user ? 'bg-gray-200' : 'bg-indigo-200 border-indigo-300'">
                    <div class="flex justify-between pb-1">
                        <div class="font-bold" v-if="!message.replied_message.is_message_by_authenticated_user">{{ message.replied_message.sender_name }}</div>
                        <div class="font-bold" v-if="message.replied_message.is_message_by_authenticated_user">You</div>
                    </div>
                    <div>{{ message.replied_message.message }}</div>
                </div>

                <!-- If there is at lease one media item then we can display a preview of the item or a thumbnail-->
                <div v-if="visibleMedia && visibleMedia.length>0" class="border rounded-lg"
                     :class="message.is_message_by_authenticated_user ? 'bg-gray-200' : 'bg-indigo-200 border-indigo-300'">
                    <div class="flex flex-wrap">
                        <div v-for="file in visibleMedia" class="p-2 w-1/2 items-stretch overflow-hidden">
                            <div class="flex flex-col items-center justify-between cursor-pointer relative" @click.prevent="download(file)">
                                <div :class="[file.type !== 'image' ? 'border rounded-lg' : '']">
                                    <!-- If its a image or a video we can display the thumbnail-->
                                    <template v-if="file.type === 'image' || file.type === 'video'">
                                        <img v-if="file.type === 'image'" style="height: 150px"
                                             @click="viewPhoto(file)" class="rounded-lg select-none"
                                             :src="file.url" :alt="file.url">
                                        <video v-if="file.type === 'video'" class="relative" style="height: 150px"
                                               @click="viewVideo(file)">
                                            <source :src="file.url + '#t=0.1'">
                                        </video>
                                        <!--Video Icon To overlay video thumbnail -->
                                        <span v-if="file.type === 'video'" class="text-white absolute right-0 top-0 mt-3 mr-3 z-50">
                                            <svg fill="none" stroke="currentColor" class="w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                      d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
                                            </svg>
                                        </span>
                                    </template>

                                    <!-- Alternatively we will display a placeholder icon -->
                                    <media-message-preview v-else
                                                           class="mr-2 select-none"
                                                           :file="file"
                                                           @click="file.type === 'video' ? viewVideo(file) : download(file)">
                                    </media-message-preview>
                                </div>
                                <div class="text-center my-2 text-xs">{{ file.name }}</div>
                            </div>
                        </div>
                    </div>

                    <button v-if="message.media.length > 4"
                            @click="showHiddenMedia = !showHiddenMedia"
                            class="text-sm text-blue-500 py-2 px-2 outline-none text-center w-full">
                        {{ showHiddenMedia ? "Collapse" : "Show All" }}
                    </button>
                </div>

                <div class="text-justify pt-3 text-sm" v-html="message.message"></div>

                <!-- Check Mark Icons To Indicate Read Status -->
                <div class="flex justify-end mt-2 -mr-1">
                    <div class="pr-2 text-sm">{{ message.sent_date }} - {{ message.sent_time }}</div>
                    <svg v-if="message.is_read_by_all" class="w-4 h-4 text-indigo-600" viewBox="0 0 24 24">
                        <path fill="currentColor"
                              d="M0.41,13.41L6,19L7.41,17.58L1.83,12M22.24,5.58L11.66,16.17L7.5,12L6.07,13.41L11.66,19L23.66,7M18,7L16.59,5.58L10.24,11.93L11.66,13.34L18,7Z"/>
                    </svg>
                    <svg v-else class="w-4 h-4 text-gray-500" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>
                    </svg>
                </div>
            </div>
        </div>
        <lightbox :images="imageUrls" :custom-event-name="viewPhotoEvent" :width="400" :height="400"></lightbox>
        <video-box :videos="videoUrls" :custom-event-name="viewVideoEvent"></video-box>
    </div>
</template>

<script>
import "../../../css/messaging.css";

export default {
    name: "MediaMessage",

    props: ["message"],

    data () {
        return {
            showDropdown: false,
            isRead: true,
            showHiddenMedia: false,
        };
    },

    computed: {
        imageUrls () {
            let photoArray = this.message.media.filter((file) => file.type === "image");
            return photoArray.map((file) => file.url);
        },

        videoUrls () {
            let videoArray = this.message.media.filter((file) => file.type === "video");
            return videoArray.map((file) => file.url);
        },

        viewPhotoEvent () {
            return "view-photos-message-" + this.message.id;
        },

        viewVideoEvent () {
            return "view-videos-message-" + this.message.id;
        },

        visibleMedia () {
            return this.showHiddenMedia ? this.message.media : this.message.media.slice(0, 4);
        }
    },

    methods: {
        replySelected () {
            Bus.$emit("reply-selected", this.message);
        },

        deleteMessage () {
            this.$emit("delete-message", this.message);
            this.showDropdown = false;
        },

        viewPhoto (file) {
            Bus.$emit(this.viewPhotoEvent, file.url);
        },

        viewVideo (file) {
            Bus.$emit(this.viewVideoEvent, file.url);
        },

        download (file) {
            if (file.type !== "image") {
                axios.get("/messages/media/" + this.message.id + "/single", {
                    params: {
                        file_uuid: file.uuid,
                    }
                })
                .then((response) => {
                    window.open(response.data, "_blank");
                })
                .catch((error) => {
                    toastr.error("Could Not Download Media! " + error.message);
                });
            }
        },

        downloadAllMedia () {
            axios.get("/messages/media/" + this.message.id)
            .then((response) => {
                window.location.href = response.data;
            })
            .catch((error) => {
                toastr.error("Could Not Download Media! " + error.message);
            });
        },

        hideDropdown(){
            this.showDropdown = false;
        },
    },
};
</script>

<style scoped>

</style>
